import Search from './code/Scripts/Directives/search';

export default {
  directives: {
    Search,
  },
};
